import { createRouter, createWebHistory } from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Notfound from "../views/404.vue";
import store from "@/store";
import Login from '../views/User/Login'

const routes = [
  {
    path: "/user",
    name: "user",
    hideInMenu: true,
    children: [
      {
        path: "/user/login",
        name: "login",
        component: () =>
          import(/* webpackChunkName: "login" */ "../views/User/Login"),
      },
      {
        path: "/user/register",
        name: "register",
        component: () =>
          import(/* webpackChunkName: "register" */ "../views/User/Register"),
      },
    ],
  },
  {path:'/',redirect:'/login'},
  {path:'/login',component:Login},
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    hideInMenu: true,
    component: Notfound,
  },
  {
    path: "/about",
    name: "about",
    hideInMenu: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  const userMenus = localStorage.getItem('userMenus')
  if(!userMenus && to.path !== '/User/Login') {
    return next('/User/Login')
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
